import React, {Component} from 'react'
import styled from 'styled-components';
import { media } from '../../styles/utils'

import { Wrapper, Label, Input } from '../InputText/InputText';

class InputText extends Component {
    
    render() {

        return (
            <Wrapper>
                <Label>{this.props.label}</Label>
                <Input 
                    type="email"
                    name={this.props.name}
                    // placeholder={this.props.placeholder}
                    value={this.props.value}
                    onChange={this.props.onChangeValue}
                    required
                />
            </Wrapper>
        )
    }
}


export default InputText;


// WEBPACK FOOTER //
// ./client/components/InputEmail/InputEmail.js